import { makeAutoObservable } from 'mobx';

type Slider = {
    prev: {
        type: string,
        index: number,
        value: any,
        items: any[],
    },
    next: {
        type: string,
        index: number,
        value: any,
        items: any[],
    },
    curr: {
        type: string,
        index: number,
        value: any,
        itemsRaw: any[],
        items: any[],
    },
};

export default class CommonStore {
    slider: Slider = {
        prev: {
            type: '',
            index: 0,
            value: null,
            items: [],
        },
        next: {
            type: '',
            index: 0,
            value: null,
            items: [],
        },
        curr: {
            type: '',
            index: 0,
            value: null,
            items: [],
            itemsRaw: [],
        },
    };

    constructor() {
        makeAutoObservable(this);
    }
}
